import { getCookie } from 'cookies-next';

export const fetchWithAuth = async (url: string, options: RequestInit = {}) => {
  const token = getCookie('sesion_t');
  
  if (!token) {
    throw new Error('No se encontró un token de acceso');
  }
  
  const headers = {
    ...options.headers,
    Authorization: `Bearer ${token}`,
  };
  
  const response = await fetch(url, { ...options, headers });
  
  if (!response.ok) {
    throw new Error(`Error en la solicitud: ${response.status} ${response.statusText}`);
  }
  
  return response;
};

export default fetchWithAuth;
